import axios from "axios";

export default {
    serviceWorkerStart() {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.register('/serviceWorker.min.js').
                then(function (reg) {
                }).catch(function (error) {
                    console.log(error);
                });

            navigator.serviceWorker.onmessage = function (event) {
                if (event.data.command == "SignOut") {
                    location.reload();
                }
            }
        }
    }
}